import React from 'react';
import {connect} from 'react-redux';

import Dropzone from 'components/Dropzone';
import {uploadFile, ACCEPTED_FILE_TYPES} from 'ducks/files';
import {verifyKycDocumentsUpload} from 'ducks/bookings';
import {storeDataInModal, selectModal} from 'ducks/modals';
import {MODALS, fetchMemberCheckInInfo} from 'ducks/frontDesk';
import {signKycIdentificationDocument} from 'sdk/bookings';

class PoidDocumentDropzone extends React.Component<any> {
  state = {files: []};

  removeFile = () => this.setState({files: []});

  onFileDrop = files => {
    const file = files[0];
    const signData = {
      filename: file.name,
      fileType: file.type,
      owner: this.props.tenantId
    };

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.MEMBER_CHECK_IN,
        data: {
          uploading: true
        }
      });

    const finishUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.MEMBER_CHECK_IN,
        data: {
          uploading: false
        }
      });

    const storeIdentifierAction = identifier =>
      verifyKycDocumentsUpload({poid: identifier, kyc: this.props.kycId}, [
        () =>
          fetchMemberCheckInInfo(
            {
              locationRef: this.props.locationRef,
              bookingId: this.props.bookingId
            },
            this.props.fetchMemberCheckInInfoExtraActions()
          )
      ]);

    this.setState({files}, () =>
      this.props.uploadFile({
        file,
        signData,
        startUploadingAction,
        finishUploadingAction,
        storeIdentifierAction,
        signSdk: signKycIdentificationDocument
      })
    );
  };

  render() {
    const {uploading, className} = this.props;
    return (
      <div className={className}>
        <Dropzone
          onDrop={this.onFileDrop}
          multiple={false}
          files={this.state.files}
          uploading={uploading}
          acceptedFileTypes={ACCEPTED_FILE_TYPES}
          disablePreview={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {data: {uploading}} = selectModal(state, MODALS.MEMBER_CHECK_IN);

  return {
    uploading
  };
};

const mapDispatchToProps = {uploadFile};

export default connect(mapStateToProps, mapDispatchToProps)(
  PoidDocumentDropzone
);
